<template>
  <div class="report-list">
    <el-row>
      <el-col :span="24">
        <div class="box">
          <el-row>
            <el-col :span="24">
              <h1>Descarga de reportes</h1>
            </el-col>
          </el-row>
          <el-form
            v-loading.fullscreen.lock="fullscreenLoading"
            ref="form"
            :model="model"
            :label-position="top"
            :rules="rules">
            <el-row
              :gutter="20"
              type="flex"
              class="row-bg"
              style="align-items: center;">
              <el-col
                :xs="4"
                :sm="6"
                :md="8"
                :lg="6"
                :xl="6">
                <el-form-item
                  label="Tipo de reporte"
                  prop="type">
                  <el-select
                    v-model="model.type"
                    style="width: 100%"
                    placeholder="Selecciona el tipo">
                    <el-option
                      v-for="item in optionsType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :xs="4"
                :sm="7"
                :md="8"
                :lg="6"
                :xl="6">
                <el-form-item
                  label="Fecha de Inicio"
                  prop="dateStart">
                  <el-date-picker
                    v-model="model.dateStart"
                    style="width: 100%"
                    type="date"
                    placeholder="Selecciona la fecha de inicio"/>
                </el-form-item>
              </el-col>
              <el-col
                :xs="4"
                :sm="6"
                :md="8"
                :lg="6"
                :xl="6">
                <el-form-item
                  label="Fecha final"
                  prop="dateEnd">
                  <el-date-picker
                    v-model="model.dateEnd"
                    style="width: 100%"
                    type="date"
                    placeholder="Selecciona la fecha final"/>
                </el-form-item>
              </el-col>
              <el-col
                :xs="4"
                :sm="6"
                :md="8"
                :lg="6"
                :xl="6">
                <el-button
                  type="primary"
                  style="width: 100%;margin-top: 13px;"
                  @click="onSubmit">
                  Descargar
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/**
*
* ReportList Component
*
* @author emartinez
* @copyright 2019, Marciano Studio S.C.
*/
import http from '@/services/http.service'
import moment from 'moment'
export default {
  name: 'ReportList',
  data () {
    let validationDateEnd = (rule, value, callback) => {
      let _dateStart = moment(this.model.dateStart).add(1, 'days').format('X')
      let _dateEnd = moment(value).format('X')
      if (this.model.dateStart === null) {
        callback()
      } else if (_dateEnd < _dateStart) {
        callback(new Error('Seleccione una fecha mayor.'))
      } else {
        callback()
      }
    }
    let validationDateStart = (rule, value, callback) => {
      let _dateStart = moment(value).format('X')
      let _dateEnd = moment(this.model.dateEnd).subtract(1, 'days').format('X')
      if (this.model.dateEnd === null) {
        callback()
      } else if (_dateStart > _dateEnd) {
        callback(new Error('Seleccione una fecha menor.'))
      } else {
        callback()
      }
    }
    return {
      top: 'top',
      fullscreenLoading: false,
      model: {
        type: null,
        dateStart: null,
        dateEnd: null
      },
      rules: {
        type: [
          { required: true, message: 'Seleccione un tipo de reporte', trigger: 'blur' }
        ],
        dateStart: [
          { validator: validationDateStart, trigger: 'blur' }
        ],
        dateEnd: [
          { validator: validationDateEnd, trigger: 'blur' }
        ]
      },
      optionsType: [
        {
          label: 'Maquinarias',
          value: 'machineries'
        },
        {
          label: 'Oportunidades',
          value: 'opportunities'
        },
        {
          label: 'Seguimientos',
          value: 'trackings'
        },
        {
          label: 'Actividades',
          value: 'activities'
        }
      ]
    }
  },
  methods: {
    onSubmit () {
      this.fullscreenLoading = true
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let URL = `${process.env.API_URL}reports/download?type=${this.model.type}`
          if (this.model.dateStart) {
            let dateStart = moment(this.model.dateStart).format('YYYY-MM-DD')
            let dateEnd = moment(this.model.dateEnd).format('YYYY-MM-DD')
            URL += `&filters[where][createdAt][gte]=${dateStart}T00:00:00.000Z&filters[where][createdAt][lte]=${dateEnd}T23:59:59.000Z`
          }
          http
            .get(URL, {
              responseType: 'blob'
            })
            .then(response => {
              let type = ''
              switch (this.model.type) {
                case 'machineries':
                  type = 'MAQUINARIAS'
                  break
                case 'opportunities':
                  type = 'OPORTUNIDADES'
                  break
                case 'trackings':
                  type = 'SEGUIMIENTOS'
                  break
                case 'activities':
                  type = 'ACTIVIDADES'
                  break
                default:
                  break
              }
              let _day = moment().format('DD-MM-YYYY')
              let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = `AGCO_CRM_${type}_${_day}.xlsx`
              this.model.type = null
              link.click()
            }).catch(error => {
              return Promise.reject(error)
            }).finally(() => {
              this.fullscreenLoading = false
            })
        } else {
          this.fullscreenLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.report-list {
  padding: 30px;
  .box {
    background-color: #FFF;
    border: 1px solid #DDDDDD;
    border-radius: 3px;
    padding: 30px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.19);
    h1 {
      @include font-primary(21px, regular);
      color: #707070;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/report/report-list.vue